import { render } from "./ProjectIcon.vue?vue&type=template&id=d67e4652"
import script from "./ProjectIcon.vue?vue&type=script&lang=js"
export * from "./ProjectIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__